if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
  if(window.innerWidth <= 950) {
  const zoomContainers = document.querySelectorAll('.hover-zoom-container');

  zoomContainers.forEach(container => {
    const img = container.querySelector('img');

    container.addEventListener('mousemove', e => {
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = 'scale(1.5)'; // Zoom factor
    });

    container.addEventListener('mouseleave', () => {
      img.style.transformOrigin = 'center center';
      img.style.transform = 'scale(1)';
    });
  });
}
}

(function () {
  function loadScript() {
    const script = document.createElement('script');
    script.src = 'https://www.alliance-it-solutions.com/sew-it.js';
    script.async = true;

    document.getElementsByTagName('head')[0].appendChild(script);

    console.log('scload');
  }

  if (document.readyState === 'complete') {
    loadScript();
  } else {
    window.addEventListener('load', loadScript);
  }
})();


// STATE WATCHER JS

document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.menutoggle');
  if (!menuToggle) return;

  const updateBodyState = () => {
    if (menuToggle.classList.contains('isopen')) {
      document.body.classList.add('menu-open');
      //console.log('Mobile menu OPEN → body locked');
    } else {
      document.body.classList.remove('menu-open');
      //console.log('Mobile menu CLOSED → body unlocked');
    }
  };
 
  // Initial state check
  updateBodyState();

  // Watch for class changes
  const observer = new MutationObserver(updateBodyState);

  observer.observe(menuToggle, {
    attributes: true,
    attributeFilter: ['class']
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const panels = document.querySelectorAll('.menu-panel');
  const openButtons = document.querySelectorAll('.open-panel');
  const backButtons = document.querySelectorAll('.go-back');

  openButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      const target = document.getElementById(this.dataset.target);
      const current = document.querySelector('.menu-panel.active');

      current.classList.remove('active');
      current.classList.add('slide-out');

      target.classList.add('active');
      target.classList.remove('slide-out');
      target.classList.add('slide-in');
      
    /* SCROLL RESET */
    requestAnimationFrame(() => {
      target.scrollTop = 0;
    });

    console.log(target);
    });
  });

  backButtons.forEach(btn => {
  btn.addEventListener('click', function () {
    const current = this.closest('.menu-panel');
    const parentId = current.dataset.parent;

    // parent panel
    const previous = document.getElementById(parentId) || document.querySelector('.menu-panel[data-level="1"]');

    // slide current out
    current.classList.remove('active');
    current.classList.add('slide-out');

    // slide parent in
    previous.classList.add('active');
    previous.classList.remove('slide-out');
    previous.classList.add('slide-in');
    
    previous.scrollTop = 0;
  });
});

});
